import { render } from "./Funfact.vue?vue&type=template&id=0e8e9b59"
import script from "./Funfact.vue?vue&type=script&lang=js"
export * from "./Funfact.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__